module.exports = "images/doc-city-menu.8241af623aa1b6b56661a3d914814890.png";